import graphqlClient from "../../../apollo";

class StockDailyProvider {

    findStockDaily(id) {
        return graphqlClient.query({
            query: require('./gql/StockDaily/findStockDaily.graphql'),
            variables: {id:id}
        })
    }

    fetchStockDaily() {
        return graphqlClient.query({
            query: require('./gql/StockDaily/fetchStockDaily.graphql'),
            fetchPolicy: "network-only"
        })
    }

    fetchStockDailyFromDate(date) {
        return graphqlClient.query({
            query: require('./gql/StockDaily/fetchStockDailyFromDate.graphql'),
            fetchPolicy: "network-only",
            variables: {date}
        })
    }

    paginateStockDaily(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/StockDaily/paginateStockDaily.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }



    createStockDaily(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockDaily/createStockDaily.graphql'),
            variables: {input}
        })
    }

    updateStockDaily(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockDaily/updateStockDaily.graphql'),
            variables: {id, input}
        })
    }

     deleteStockDaily(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockDaily/deleteStockDaily.graphql'),
            variables: {id}
        })
    }

}

export default new StockDailyProvider()


